module.exports = __webpack_public_path__ + "media/images/pc/specials/common/special_c_06-58cdcad2f09194adc261f12b0a6a18b8.png";